import React, {useState} from "react";
import {isEmpty} from "lodash";
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {createDashboard, updateDashboard} from "../../redux/Actions/tsdb.actions";
import {_Buttons} from "../../constants/appConstants";
import ZeusButton from "../Button";
import InputCreator from "../Forms/components/InputCreator";

const AddDashboard = (props) => {
  const {data, handleClose, headerName, open = false, updateCallback} = props;
  const dispatch = useDispatch();
  const [payload, setPayload] = useState(data || {});
  const [showInvalid, setShowInvalid] = useState(false);

  const isEdit = data && data.id;

  const handleChange = (event) => {
    const {value, name} = event.target;
    setPayload({...payload, [name]: value});
  };

  const handleSubmit = () => {
    if (isEmpty(payload.name)) {
      setShowInvalid(true);
      toast.error("Please check required fields");
    } else {
      if (isEdit) {
        dispatch(
          updateDashboard(
            {
              id: data.id,
              name: payload.name,
              description: payload.description,
            },
            handleClose,
            updateCallback
          )
        );
      } else {
        dispatch(
          createDashboard(
            {
              name: payload.name,
              description: payload.description,
            },
            handleClose,
            updateCallback,
            headerName
          )
        );
      }
    }
  };

  return (
    <Modal
      data-cy={"select_sites_dropdown"}
      unmountOnClose={true}
      isOpen={open}
      backdrop={"static"}
    >
      <ModalHeader>
        {isEdit ? "Edit" : "Add"} {headerName}
      </ModalHeader>
      <ModalBody>
        <div className="pl-lg-4">
          <Row>
            <InputCreator
              large
              label={"Name"}
              className="form-control-alternative"
              placeholder={"name"}
              type="text"
              name={"name"}
              onChange={handleChange}
              value={payload.name}
              data-cy="snapshotName"
              invalid={showInvalid && isEmpty(payload.name)}
              isRequired
            />
          </Row>
          <Row>
            <InputCreator
              large
              label={"Description"}
              className="form-control-alternative"
              placeholder={"description"}
              type="textarea"
              name={"description"}
              onChange={handleChange}
              value={payload.description}
              data-cy="snapshotDesc"
            />
          </Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
          {isEdit ? _Buttons.SAVE : _Buttons.ADD}
        </ZeusButton>
        <ZeusButton data-cy="cancel-btn" type={"info-small"} onClick={handleClose}>
          {_Buttons.CANCEL}
        </ZeusButton>
      </ModalFooter>
    </Modal>
  );
};

AddDashboard.propTypes = {
  open: PropTypes.bool,
};
export default AddDashboard;
